var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOperation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.23,
    height: 18,
    viewBox: "0 0 16.23 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.208,2.611a2.6,2.6,0,0,0-2.6-2.6H7.167V1.057A12.69,12.69,0,0,0,1.1,2.933V0H-.022V18H1.1V4.31A11.314,11.314,0,0,1,7.167,2.192V3.509H8.258c.4.933,1.772,1.587,3.516,1.587s3.116-.654,3.517-1.587h.917ZM8.292,1.141h5.319a1.472,1.472,0,0,1,1.454,1.243H8.292Zm3.482,2.83a4.136,4.136,0,0,1-2.017-.462h4.034A4.13,4.13,0,0,1,11.774,3.971Z",
    transform: "translate(0.022)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOperation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/operation.60c9adc7dda9bc26746fb5b21d232b96.svg";